export const SAVE_NEW_DEPENDENT_QUERY_KEY = ['add new', 'dependents'] as const;
